import React from 'react'
import FlexColumn from '../FlexColumn'
import FlexRow from '../FlexRow'
import LinkButton from '../LinkButton'
import Text from '../Text'
import { StyleProps } from 'types/style'
import { Option } from 'shared/types'

type Props = {
  tabs: Option[]
  value: any
  onChange: Function
  styleProps?: StyleProps
}

export default function VerticalTabBar(props: Props) {
  const { tabs, value, onChange, styleProps } = props

  return (
    <FlexColumn {...styleProps?.boxProps}>
      {tabs.map((tab, idx) => {
        return (
          // @ts-ignore
          <LinkButton
            key={tab.label}
            onClick={() => onChange(tab)}
            mb={idx === tabs.length - 1 ? 'none' : 'medium'}
            textAlign="left"
            whiteSpace="initial"
            color="neutral.6"
            hoverColor="navHover"
          >
            <FlexRow
              alignItems="center"
              color={tab.value === value ? 'accent.lightblue' : 'inherit'}
            >
              <Text
                fontWeight={tab.value === value ? 'bold' : 'normal'}
                fontSize="large"
                color="inherit"
              >
                {tab.label}
              </Text>
              {tab.iconComponent && <FlexRow ml="small">{tab.iconComponent}</FlexRow>}
            </FlexRow>
          </LinkButton>
        )
      })}
    </FlexColumn>
  )
}
